module.exports = __webpack_public_path__ + "img/awardsUde1.74894275.png";